import React, { Component } from "react";
import Footer from "./components/Footer.js";
//import Menu from "./components/Menu.js";
import Menu2 from "./components/NewMenu.js"

import "./styles/technicalDetails.css"

// imports for altmetrics metadata
import ReactDependentScript from 'react-dependent-script';
import MetaTags from 'react-meta-tags';
import { Helmet } from "react-helmet"

//Import PNG Image

import GraphHover from "./components/GraphHover.js";

//Import article
import PDFArticle from './articles/The_NZ_Shared_Prosperity_Composite_Index.pdf';

class MainArticle extends Component {

  constructor(props) {
    super(props);
    this.state = {
      displayGraph: "none",
      graphTitle: null,
      graphPreview: null,
      graphHoverLeft: "0",
      previewImages: null,
    };
    this._onMouseLeave = this._onMouseLeave.bind(this);
    this.DisplayHoverGraph = this.DisplayHoverGraph.bind(this);
  }

  _onMouseLeave(evt) {
    this.setState({ displayGraph: "none" });
  }

  DisplayHoverGraph(input, image, evt) {
    //Disable hover effect if on a mobile device
    if (!this.props.isMobileDevice) {
      this.setState({
        graphTitle: input,
        previewImage: image,
        displayGraph: "inline"
      });

      if (evt.clientX < window.screen.width / 2) {
        this.setState({ graphHoverLeft: "1200px" });
      } else {
        this.setState({ graphHoverLeft: "0" });
      }
    }
  }

  render() {

    return (
      <div>
        <MetaTags>
          <meta property="og:type" content="article"></meta>
          <meta name="citation_doi" content="10.33217/KEH/SharedProsperity/001/05.2019"></meta>
          <meta property="og:url" content="https://www.sharedprosperity.co.nz/static/media/The_NZ_Shared_Prosperity_Composite_Index.36eb69be.pdf"></meta>
          <meta property="og:title" content="The NZ Shared Prosperity Composite Index"></meta>
          <meta name="dc.Title" content="The NZ Shared Prosperity Composite Index"></meta>
          <meta name="dc.Creator" content=" Teo Susnjak "></meta>
          <meta name="Dc.Identifier" scheme="doi" content="10.33217/KEH/SharedProsperity/001/05.2019"></meta>
          <meta name="DC.Identifier" content="10.33217/KEH/SharedProsperity/001/05.2019" />
          <meta name="citation_pdf_url" content="https://gdp-live.s3-ap-southeast-2.amazonaws.com/The_NZ_Shared_Prosperity_Composite_Index.pdf"></meta>

          <meta name="citation_title" content="Towards A Global Index Of Shared Prosperity: A Case Study On New Zealand"></meta>
          <meta name="citation_author" content="Susnjak, Teo"></meta>
          <meta name="citation_author" content="Schumacher, Christoph"></meta>
          <meta name="citation_author" content="Ali, Ajmol"></meta>
          <meta name="citation_author" content="Brook, Alison"></meta>
          <meta name="citation_author" content="Geertsema, Paul"></meta>
          <meta name="citation_author" content="Matthewson, John"></meta>
          <meta name="citation_author" content="Owens, Rachel"></meta>
          <meta name="citation_author" content="Smith, Jeremy"></meta>

          <meta name="citation_date" content="2019"></meta>
          <meta name="citation_pdf_url" content="https://gdp-live.s3-ap-southeast-2.amazonaws.com/The_NZ_Shared_Prosperity_Composite_Index.pdf"></meta>

        </MetaTags>

        <Helmet>
          <meta property="og:type" content="article"></meta>
          <meta name="citation_doi" content="10.33217/KEH/SharedProsperity/001/05.2019"></meta>
          <meta property="og:url" content="https://www.sharedprosperity.co.nz/static/media/The_NZ_Shared_Prosperity_Composite_Index.36eb69be.pdf"></meta>
          <meta property="og:title" content="Towards a global index of shared prosperity: a case study on New Zealand"></meta>
          <meta name="dc.Title" content="Towards a global index of shared prosperity: a case study on New Zealand"></meta>
          <meta name="dc.Creator" content=" Teo Susnjak "></meta>
          <meta name="Dc.Identifier" scheme="doi" content="10.33217/KEH/SharedProsperity/001/05.2019"></meta>
          <meta name="DC.Identifier" content="10.33217/KEH/SharedProsperity/001/05.2019" />
          <meta name="citation_pdf_url" content="https://gdp-live.s3-ap-southeast-2.amazonaws.com/The_NZ_Shared_Prosperity_Composite_Index.pdf"></meta>

          <meta name="citation_title" content="Towards A Global Index Of Shared Prosperity: A Case Study On New Zealand"></meta>
          <meta name="citation_author" content="Susnjak, Teo"></meta>
          <meta name="citation_author" content="Schumacher, Christoph"></meta>
          <meta name="citation_author" content="Ali, Ajmol"></meta>
          <meta name="citation_author" content="Brook, Alison"></meta>
          <meta name="citation_author" content="Geertsema, Paul"></meta>
          <meta name="citation_author" content="Matthewson, John"></meta>
          <meta name="citation_author" content="Owens, Rachel"></meta>
          <meta name="citation_author" content="Smith, Jeremy"></meta>

          <meta name="citation_date" content="2019"></meta>
          <meta name="citation_pdf_url" content="https://gdp-live.s3-ap-southeast-2.amazonaws.com/The_NZ_Shared_Prosperity_Composite_Index.pdf"></meta>


        </Helmet>

        <ReactDependentScript
          loadingComponent={<div></div>}
          scripts={['https://d1bxh8uas1mnw7.cloudfront.net/assets/embed.js']}
        >
          <div></div>
        </ReactDependentScript>


        <GraphHover
          position="fixed"
          top={this.state.graphHoverTop}
          left={this.state.graphHoverLeft}
          displayPreview={true}
          display={this.state.displayGraph}
          graphTitle={this.state.graphTitle}
          previewImage={this.state.previewImage}
          graphHeadingSize={this.state.graphHeadingSize}
          width={this.state.graphHoverWidth}
          height={this.state.graphHoverHeight}
        />
        <div className="bgded overlay">
          {/* Menu */}
          <Menu2 ChangeViewButtonClick={this.props.ChangeViewButtonClick} />
        </div>

        {/* Start of Machine Learning Algorithms */}
        <div className="wrapper row3">
          <a id="technicalreport" />
          <main className="hoc container clear" style={{ paddingTop: "30px" }}>
            <article className="one_third first" style={{ width: "100%" }}>
              <h4 className="font-x2 font-x3">Article</h4>

              <p>

              </p>

              <div id="wrapper">
                <div>
                  <div id="first" data-badge-details="right" data-badge-type="donut" data-doi="10.33217/KEH/SharedProsperity/001/05.2019" data-hide-no-mentions="true" data-hide-less-than="3" className="altmetric-embed"></div>
                </div>


                <div id="second">
                  <div>
                    <h2 className="article-title">Towards a global index of shared prosperity: a case study on New Zealand</h2>
                  </div>


                  <div className="article-content">
                    <div className="article-row">
                      <label className="display-label">Abstract: </label>
                      <span className="display-label-result">Global prosperity has been rising over the last decade, along with public debate about growing inequality and its poten- tially negative social and economic consequences. The purpose of our research is to create an annually updated com- posite index, The Shared Prosperity Index (SPI), to quantify and visualise how effectively prosperity has been shared in New Zealand over time as well as near-future predictions. Past measures of inequality have tended to focus on a single factor such as income distribution, but in recent years a number of composite indices have emerged internation- ally which have attempted to provide a multi-dimensional perspective regarding prosperity and collective wellbeing. The SPI is differentiated from the existing measures by emphasising the idea of shared rather than absolute prosper- ity and employing a particular focus on the New Zealand context. The SPI employs eight multivariate dimensions identified as drivers of shared prosperity: income and wealth, employment, housing, health, socio-economic wellbe- ing, education, safety and security, and general equality, and incorporates national and international data sources to compute a composite index. The SPI begins in 1982, and results show that the level of sharing from then reached a peak in New Zealand during the early to mid-1980s, before dropping sharply between 1987 and 1994, coinciding with cuts to government services and a move to a more open and less-regulated economy. Shared prosperity began slowly rising again until 2007 when it flattened out and trended downwards. In terms of eight individual SPI dimensions, we find most indices, while displaying some variability, reflect an overall decrease in sharing over their respective time-spans. The largest drop is in the Income and Wealth index, consistent with international findings on the growing gap between the rich and poor. The indices for two dimensions, Safety and Security and Education, have increased over their time-spans, although the Education index appears to be trending down.</span>
                    </div>

                    <div className="article-row">
                      <label className="display-label">Authors: </label>
                      <span className="display-label-result">Teo Susnjak, Christoph Schumacher, Ajmol Ali, Alison Brook, Paul Geertsema, John Matthewson, Rachel Owens, Jeremy Smith</span>
                    </div>

                    <div className="article-row">
                      <label className="display-label">Year: </label>
                      <span className="display-label-result">2019</span>
                    </div>

                    <div className="article-row">
                      <label className="display-label">Report Number: </label>
                      <span className="display-label-result">1</span>
                    </div>

                    <div className="article-row">
                      <label className="display-label">Publisher: </label>
                      <span className="display-label-result">Knowledge Exchange Hub, Massey University</span>
                    </div>

                    <div className="article-row">
                      <label className="display-label">Place Of Publication: </label>
                      <span className="display-label-result">Auckland, New Zealand</span>
                    </div>

                    <div className="article-row">
                      <label className="display-label">DOI: </label>
                      <span className="display-label-result"><a href="https://doi.org/10.33217/KEH/SharedProsperity/001/05.2019">https://doi.org/10.33217/KEH/SharedProsperity/001/05.2019</a></span>
                    </div>

                    <div className="article-row">
                      <label className="display-label">Source: </label>
                      <span className="display-label-result"><a href="https://gdp-live.s3-ap-southeast-2.amazonaws.com/The_NZ_Shared_Prosperity_Composite_Index.pdf">Download PDF</a></span>
                    </div>

                  </div>

                </div>

              </div>



            </article>
            <div className="clear" />
          </main>
        </div>


        <Footer />
      </div>
    );
  }
}



class DownloadPDF extends Component {

  render() {

    return (
      <div >
        <a href={PDFArticle} target="_blank">Download PDF</a>
      </div>
    );
  }
}

export default MainArticle;
